/**
 * @generated SignedSource<<ea67e7deba169593a849f9e7a8824e69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type clickupStreamDetails$data = {
  readonly clickupUser: {
    readonly id: string;
    readonly user: {
      readonly fullName: string;
    };
  };
  readonly externalFolderId: string;
  readonly externalListId: string;
  readonly externalListName: string;
  readonly externalSpaceId: string;
  readonly externalWorkspaceId: string;
  readonly includeAiGenerated: boolean;
  readonly " $fragmentType": "clickupStreamDetails";
};
export type clickupStreamDetails$key = {
  readonly " $data"?: clickupStreamDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"clickupStreamDetails">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "clickupStreamDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClickupUserNode",
      "kind": "LinkedField",
      "name": "clickupUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalListName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAiGenerated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalListId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalWorkspaceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalSpaceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalFolderId",
      "storageKey": null
    }
  ],
  "type": "ClickupStreamIntegrationNode",
  "abstractKey": null
};

(node as any).hash = "347f2f0e1b1754288a38977037b8590e";

export default node;
